// AUTO-GENERATED — do not edit. Run `pnpm build` in packages/domain-data.
// Source: business/ishvaram/data/domain/astrology/tarot.yaml

import type { TarotReferenceCard } from "./types";

export const pentaclesTarotCards = [
  {
    image_description: "",
    id: 64,
    name_en: "Ace of Pentacles",
    name_hi: "सिक्के का इक्का",
    vedic_name: "Lakshmi Beej (Seed of Prosperity)",
    vedic_parallel: "Like Lakshmi emerging from the ocean — the first gift of material abundance",
    upright: {
      keywords: ["new opportunity", "prosperity", "financial gain", "manifestation"],
      meaning: "A material opportunity manifests — job, investment, or windfall.",
      advice: "Plant this seed wisely. Prosperity favors the prepared.",
    },
    reversed: {
      keywords: ["missed opportunity", "financial loss", "poor planning", "instability"],
      meaning: "A financial opportunity slips by or an investment falters.",
      advice: "Review your approach to money and material goals.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 65,
    name_en: "Two of Pentacles",
    name_hi: "सिक्के का दो",
    vedic_name: "Santulan Kala (The Art of Balance)",
    vedic_parallel: "Like a merchant balancing trade routes — juggling demands with skill",
    upright: {
      keywords: ["balance", "adaptability", "juggling priorities", "time management"],
      meaning: "Multiple demands require careful balancing. Flexibility is key.",
      advice: "Keep moving, keep adjusting. The balance is dynamic, not static.",
    },
    reversed: {
      keywords: ["overwhelm", "imbalance", "financial disarray", "dropped responsibilities"],
      meaning: "Too many plates spinning. Something is about to drop.",
      advice: "Simplify. Cut one commitment before all of them suffer.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 66,
    name_en: "Three of Pentacles",
    name_hi: "सिक्के का तीन",
    vedic_name: "Sahyog Shilpa (The Craft of Collaboration)",
    vedic_parallel:
      "Like the architects of ancient temples — mastery through teamwork and devotion",
    upright: {
      keywords: ["teamwork", "craftsmanship", "collaboration", "skill", "planning"],
      meaning:
        "Skilled work recognized. Collaboration elevates the result beyond individual effort.",
      advice: "Work with others. Mastery is refined through feedback.",
    },
    reversed: {
      keywords: ["lack of teamwork", "poor quality", "disorganization", "misalignment"],
      meaning: "The team is not aligned or the work lacks quality.",
      advice: "Get everyone on the same page before proceeding.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 67,
    name_en: "Four of Pentacles",
    name_hi: "सिक्के का चार",
    vedic_name: "Kripanata (The Miser's Grip)",
    vedic_parallel:
      "Like a king hoarding treasure while his people starve — security becomes a prison",
    upright: {
      keywords: ["security", "control", "possessiveness", "savings", "conservatism"],
      meaning: "Holding tightly to what you have. Security is good but gripping is fear.",
      advice: "Save wisely but do not let fear of loss stop the flow.",
    },
    reversed: {
      keywords: ["generosity", "release", "financial risk", "overspending"],
      meaning: "Loosening the grip — either through generosity or careless spending.",
      advice: "Give freely but not foolishly.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 68,
    name_en: "Five of Pentacles",
    name_hi: "सिक्के का पाँच",
    vedic_name: "Daridrata (The Hardship)",
    vedic_parallel: "Like the Pandavas in exile — material loss that tests faith and character",
    upright: {
      keywords: ["financial loss", "poverty", "hardship", "isolation", "worry"],
      meaning:
        "Financial hardship or feeling left out in the cold. Help exists but must be sought.",
      advice: "Ask for help. The door you have not tried may be the one that opens.",
    },
    reversed: {
      keywords: ["recovery", "financial improvement", "finding support", "turning point"],
      meaning: "The worst of the hardship passes. Resources and support appear.",
      advice: "Accept the help that arrives. Pride costs more than the ask.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 69,
    name_en: "Six of Pentacles",
    name_hi: "सिक्के का छह",
    vedic_name: "Dana (The Giving)",
    vedic_parallel: "Like King Karna giving away his armor — generosity that flows from dharma",
    upright: {
      keywords: ["generosity", "charity", "sharing wealth", "receiving help", "balance"],
      meaning: "Giving or receiving with grace. Wealth flows when shared.",
      advice: "Give what you can. Generosity returns multiplied.",
    },
    reversed: {
      keywords: ["strings attached", "power dynamics", "selfishness", "debt"],
      meaning: "Generosity with conditions, or debts that create dependency.",
      advice: "Give freely or not at all. Conditional giving is a transaction.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 70,
    name_en: "Seven of Pentacles",
    name_hi: "सिक्के का सात",
    vedic_name: "Phal Prateeksha (Awaiting the Harvest)",
    vedic_parallel: "Like a farmer watching monsoon clouds — patience between sowing and reaping",
    upright: {
      keywords: ["patience", "long-term investment", "perseverance", "assessment"],
      meaning: "The seeds are planted and growing. Patience is needed before the harvest.",
      advice: "Do not dig up seeds to check if they are growing.",
    },
    reversed: {
      keywords: ["impatience", "poor returns", "wasted effort", "doubt"],
      meaning: "Questioning whether the investment of time and effort was worth it.",
      advice: "Reassess honestly. Some fields need more time; others need replanting.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 71,
    name_en: "Eight of Pentacles",
    name_hi: "सिक्के का आठ",
    vedic_name: "Abhyasa (The Practice)",
    vedic_parallel:
      "Like Ekalavya perfecting archery alone — mastery through dedicated, daily practice",
    upright: {
      keywords: ["skill development", "craftsmanship", "diligence", "apprenticeship"],
      meaning: "Mastery comes through repetition. Dedicated work builds something lasting.",
      advice: "Keep refining your craft. Excellence is built one day at a time.",
    },
    reversed: {
      keywords: ["lack of focus", "perfectionism", "mediocrity", "shortcuts"],
      meaning: "Cutting corners or obsessing over perfection instead of progressing.",
      advice: "Done well is better than done perfectly. Ship the work.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 72,
    name_en: "Nine of Pentacles",
    name_hi: "सिक्के का नौ",
    vedic_name: "Swavalamban (Self-Reliance)",
    vedic_parallel: "Like a queen in her own garden — abundance earned through personal effort",
    upright: {
      keywords: ["self-sufficiency", "luxury", "financial independence", "discipline", "gratitude"],
      meaning: "You have built something beautiful through your own effort. Enjoy the fruit.",
      advice: "Savor your success. This was earned, not given.",
    },
    reversed: {
      keywords: ["overworking", "financial setback", "superficial success"],
      meaning:
        "The appearance of success without inner fulfillment, or setbacks threaten stability.",
      advice: "Ensure your prosperity has depth, not just display.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 73,
    name_en: "Ten of Pentacles",
    name_hi: "सिक्के का दस",
    vedic_name: "Vansh Samriddhi (Generational Wealth)",
    vedic_parallel: "Like the great dynasties of Vedic kings — legacy that sustains generations",
    upright: {
      keywords: ["legacy", "inheritance", "family wealth", "long-term success", "tradition"],
      meaning: "Lasting wealth and family legacy. What you build benefits generations.",
      advice: "Think beyond yourself. The greatest wealth is what outlives you.",
    },
    reversed: {
      keywords: ["family disputes", "financial loss", "short-term thinking", "broken legacy"],
      meaning: "Family disagreements over material matters or legacy threatened.",
      advice: "Protect the family first, the fortune second.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 74,
    name_en: "Page of Pentacles",
    name_hi: "सिक्के का राजकुमार",
    vedic_name: "Prithvi Shishya (The Earth Student)",
    vedic_parallel: "Like a young Chandragupta learning economics — eager to build, ready to learn",
    upright: {
      keywords: ["new financial opportunity", "study", "ambition", "planning", "diligence"],
      meaning: "A practical new opportunity or the beginning of a study. Grounded ambition.",
      advice: "Take the first practical step. Plans on paper do not build wealth.",
    },
    reversed: {
      keywords: ["lack of progress", "procrastination", "missed opportunity"],
      meaning: "Good intentions without follow-through. The plan stays on paper.",
      advice: "Start small but start today.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 75,
    name_en: "Knight of Pentacles",
    name_hi: "सिक्के का शूरवीर",
    vedic_name: "Prithvi Veer (The Earth Warrior)",
    vedic_parallel: "Like the tortoise in the race — slow, methodical, and ultimately victorious",
    upright: {
      keywords: ["reliability", "hard work", "routine", "patience", "thoroughness"],
      meaning: "Slow, steady, reliable progress. Not glamorous but effective.",
      advice: "Trust the process. Consistency wins over bursts of brilliance.",
    },
    reversed: {
      keywords: ["stagnation", "laziness", "perfectionism", "stuck in routine"],
      meaning: "Routine has become rut. Reliability has turned to rigidity.",
      advice: "Shake up the routine. Efficiency without adaptability is fragile.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 76,
    name_en: "Queen of Pentacles",
    name_hi: "सिक्के की रानी",
    vedic_name: "Prithvi Devi (The Earth Queen)",
    vedic_parallel: "Like Sita nurturing the earth — practical wisdom, abundance, and groundedness",
    upright: {
      keywords: ["practical", "nurturing", "financially secure", "resourceful", "generous"],
      meaning: "Practical wisdom and generous nature. You create abundance naturally.",
      advice: "Lead with practical care. Your groundedness is your gift.",
    },
    reversed: {
      keywords: ["work-life imbalance", "financial anxiety", "neglecting self"],
      meaning: "Neglecting yourself while caring for everyone and everything else.",
      advice: "You cannot nurture from depletion. Fill your own cup.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
  {
    image_description: "",
    id: 77,
    name_en: "King of Pentacles",
    name_hi: "सिक्के का राजा",
    vedic_name: "Prithvi Nayak (The Earth King)",
    vedic_parallel:
      "Like King Bhoja — prosperous, cultured, building wealth that serves the kingdom",
    upright: {
      keywords: ["wealth", "business success", "stability", "leadership", "abundance"],
      meaning: "Material mastery and financial leadership. Success built on sound foundations.",
      advice: "Use your prosperity to elevate others. Wealth has purpose beyond comfort.",
    },
    reversed: {
      keywords: ["greed", "materialism", "poor financial management", "stubbornness"],
      meaning: "Wealth pursued at the cost of everything else. Greed corrodes character.",
      advice: "Remember what money cannot buy. Legacy is more than a balance sheet.",
    },
    arcana: "minor",
    suit: "pentacles",
    element: "earth",
    vedic_element: "prithvi",
    suit_theme: "Material world, work, finances, health, and practical matters",
  },
] as const satisfies readonly TarotReferenceCard[];
